import { render, staticRenderFns } from "./interval.vue?vue&type=template&id=1ffd01cd&scoped=true"
import script from "./interval.vue?vue&type=script&lang=js"
export * from "./interval.vue?vue&type=script&lang=js"
import style0 from "./interval.vue?vue&type=style&index=0&id=1ffd01cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd01cd",
  null
  
)

export default component.exports